export class ProfileExistsValidation {
  public exists: boolean;
  public fields: string;
}
